import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Cascader} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Cascader, {
            'data': this.get('data'),
            'multiple': true,
            'ev-$model:value': function($v) {
                $this.set('values', $v);
            },
            'value': $this.get('values')
        }),
        _$ct('\n    You selected: '),
        JSON.stringify(this.get('values'))
    ], 0);
};